import { Controller } from "@hotwired/stimulus";

// Toggles time inputs when a day is marked as closed
export default class extends Controller {
  static targets = ["closedCheckbox"];

  connect() {
    this.#syncAll();
  }

  toggleDay(event) {
    this.#setRowState(event.currentTarget);
  }

  // Private

  #syncAll() {
    this.closedCheckboxTargets.forEach((checkbox) => {
      this.#setRowState(checkbox);
    });
  }

  #setRowState(checkbox) {
    const row = checkbox.closest("[data-opening-hours-target='row']");
    const inputs = row.querySelectorAll("input[type='time']");
    const closed = checkbox.checked;

    inputs.forEach((input) => {
      input.disabled = closed;
      input.classList.toggle("opacity-30", closed);
    });
  }
}
